import { Component } from '@angular/core';
import { formControl } from '@al00x/forms';
import { CacBaseDialogComponent, CacDialogLayoutComponent } from '@controladad/ng-base';
import { EditorComponent } from '../../../shared/components';

export type EditorDialogData = string;

export type EditorDialogResult = string;

@Component({
  selector: 'feature-editor-dialog',
  standalone: true,
  imports: [CacDialogLayoutComponent, EditorComponent],
  templateUrl: './editor-dialog.component.html',
  styleUrl: './editor-dialog.component.scss',
})
export class EditorDialogComponent extends CacBaseDialogComponent<EditorDialogData, EditorDialogResult> {
  control = formControl<string>();

  constructor() {
    super();
    this.control.setValue(this.data);
  }

  onSubmit() {
    const value = this.control.value;
    this.submit(value);
  }
}
